import {
  FragmentType,
  getFragmentData,
  graphql,
} from "../../../../../__generated__/gql";
import Badge from "../../../../../ui/Badge/Badge";
import Tooltip from "../../../../../ui/Tooltip/Tooltip";
import DetailSection from "../components/DetailSection";

const ArticleDetailsStatsFragment = graphql(/* GraphQL */ `
  fragment ArticleDetailsStats on Article {
    targetWordCount
    targetImageCount
    targetLinkCount
    stats {
      wordCount
      keywordDensity
      imageCount
      imageHealth
      linkCount
      readingLevel
      writingGrade
      aiDetectable
    }
  }
`);

function Stats({
  isOpen,
  setIsOpen,
  data,
}: {
  isOpen: boolean;
  setIsOpen: (value: string) => void;
  data: FragmentType<typeof ArticleDetailsStatsFragment>;
}) {
  const article = getFragmentData(ArticleDetailsStatsFragment, data);

  if (!article.stats) {
    return null;
  }

  const {
    targetWordCount,
    targetImageCount,
    targetLinkCount,
    stats: {
      wordCount,
      // keywordDensity,
      imageCount,
      linkCount,
    },
  } = article;

  const lowerWordCountBound = targetWordCount ? targetWordCount - 225 : 1600;
  const upperWordCountBound = targetWordCount ? targetWordCount + 225 : 2100;

  return (
    <DetailSection
      title="Stats"
      isOpen={isOpen}
      setIsOpen={() => setIsOpen("Stats")}
      details={[
        // {
        //   name: "Keyword density",
        //   children: (
        //     <Badge
        //       color="success"
        //       showDot={false}
        //       size="medium"
        //       variant="badge"
        //     >
        //       {`${(keywordDensity * 100).toFixed(2)}%`}
        //     </Badge>
        //   ),
        // },
        {
          name: "Word count",
          children: (
            <Tooltip
              asChild={false}
              content={`${
                wordCount >= lowerWordCountBound &&
                wordCount <= upperWordCountBound
                  ? "Within"
                  : "Outside"
              } target word count range (${lowerWordCountBound} - ${upperWordCountBound})`}
            >
              <Badge
                color={
                  wordCount >= lowerWordCountBound &&
                  wordCount <= upperWordCountBound
                    ? "success"
                    : "warning"
                }
                showDot={false}
                size="medium"
                variant="badge"
              >
                {Intl.NumberFormat().format(wordCount)}
              </Badge>
            </Tooltip>
          ),
        },
        {
          name: "Images",
          children: (
            <Tooltip
              asChild={false}
              content={`Image target ${
                !targetImageCount || imageCount >= targetImageCount
                  ? "met"
                  : "not met"
              }`}
            >
              <Badge
                color={
                  !targetImageCount || imageCount >= targetImageCount
                    ? "success"
                    : "warning"
                }
                showDot={false}
                size="medium"
                variant="badge"
              >
                {Intl.NumberFormat().format(imageCount)}
              </Badge>
            </Tooltip>
          ),
        },
        {
          name: "Links",
          children: (
            <Tooltip
              asChild={false}
              content={`Link target ${
                !targetLinkCount || linkCount >= targetLinkCount
                  ? "met"
                  : "not met"
              }`}
            >
              <Badge
                color={
                  !targetLinkCount || linkCount >= targetLinkCount
                    ? "success"
                    : "warning"
                }
                showDot={false}
                size="medium"
                variant="badge"
              >
                {Intl.NumberFormat().format(linkCount)}
              </Badge>
            </Tooltip>
          ),
        },
        // {
        //   name: "Search intent",
        //   children: (
        //     <Tooltip
        //       asChild={false}
        //       content="The search intent of the target keyword is fulfilled by the articles content."
        //     >
        //       <Badge
        //         color={"success"}
        //         showDot={false}
        //         size="medium"
        //         variant="badge"
        //       >
        //         Fulfilled
        //       </Badge>
        //     </Tooltip>
        //   ),
        // },
        // {
        //   name: "Reading level",
        //   children: (
        //     <Tooltip
        //       asChild={false}
        //       content={`${
        //         Math.floor(readingLevel) >= 6 && Math.floor(readingLevel) <= 11
        //           ? "Within"
        //           : "Outside"
        //       } target reading level range (6th-11th Grade)`}
        //     >
        //       <Badge
        //         color={
        //           Math.floor(readingLevel) >= 6 &&
        //           Math.floor(readingLevel) <= 11
        //             ? "success"
        //             : "warning"
        //         }
        //         showDot={false}
        //         size="medium"
        //         variant="badge"
        //       >
        //         {readingLevel < 13
        //           ? `${Math.floor(readingLevel)}${getOrdinal(
        //               readingLevel,
        //             )} Grade`
        //           : "College"}
        //       </Badge>
        //     </Tooltip>
        //   ),
        // },
        // {
        //   name: "Organic writing score",
        //   children: (
        //     <Tooltip
        //       asChild={false}
        //       content="Article reads as if written by a human"
        //     >
        //       <Badge
        //         color="success"
        //         showDot={false}
        //         size="medium"
        //         variant="badge"
        //       >
        //         {writingGrade}
        //       </Badge>
        //     </Tooltip>
        //   ),
        // },
        // {
        //   name: "AI detection",
        //   children: (
        //     <Tooltip
        //       content="Article content was not detected by our AI detection algorithm"
        //       asChild={false}
        //     >
        //       <Badge
        //         color="success"
        //         showDot={false}
        //         size="medium"
        //         variant="badge"
        //       >
        //         {aiDetectable ? "Detectable" : "Undetectable"}
        //       </Badge>
        //     </Tooltip>
        //   ),
        // },
      ]}
    />
  );
}

export default Stats;
